import { appLocalStorage } from '@/warehouse/helpers';
const savePrinterNameToLocalStorage = (printerName) => () => {
    appLocalStorage.setItem('printerName', printerName);
};
export { savePrinterNameToLocalStorage };
